var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "815E53C2-C70E-41F6-A3E6-ADFB2EA30736") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entity-Details-+-Data-Tracker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxPro-DT-1.0",
    transform: "translate(-1821.000000, -238.000000)",
    fill: "#677283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(1819.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upload-Small",
    transform: "translate(2.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,11 L1.5,12.5 L12.5,12.5 L12.5,11 L14,11 L14,12.5 L14,14 L0,14 L0,11 L1.5,11 Z M6.25000002,10.8106602 L6.25000002,2.8726602 L3.0303301,6.09099029 L1.96966992,5.03033012 L7.00000002,1.77635684e-15 L12.0303301,5.03033012 L10.9696699,6.09099029 L7.75000002,2.8711602 L7.75000002,10.8106602 L6.25000002,10.8106602 Z",
    id: "Upload-Small"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadSmall);
export default __webpack_public_path__ + "static/media/Icon_Upload Small.2d0b2c9a.svg";
export { ForwardRef as ReactComponent };